import React from 'react'
import { Box } from '@material-ui/core'
import OnboardingSectionTitle from '../../../_global//OnboardingSectionTitle'
import WorkExperienceForm from './Form'
import { useOnboarding } from '../../../contexts/OnboardingContext'
import { useQuery } from '@apollo/react-hooks'
import WORK_EXPERIENCE_QUERY from '../../../apolloClient/queries/getWorkExperiences'
import Error from '../../../_global/Error'
import Loader from '../../../_global/Loader'

export const initialWorkExperienceValue = {
  description: '',
  employer: '',
  endDate: null,
  industryTags: [],
  isCurrentEmployer: false,
  financialTags: [],
  softwareTags: [],
  startDate: null,
  title: '',
}

const WorkExperience = () => {
  const { currentExpert, arrayIsValid } = useOnboarding()

  const { loading, error, data } = useQuery(WORK_EXPERIENCE_QUERY, {
    variables: { id: currentExpert.id },
    skip: !currentExpert.id,
  })

  if (loading) return <Loader />
  if (error) return <Error />

  const {
    getExpert: { workExperiences },
  } = data

  const initialValues = {
    workExperiences: arrayIsValid(workExperiences) ? workExperiences : [initialWorkExperienceValue],
  }

  return (
    <>
      <Box>
        <OnboardingSectionTitle
          title="Work Experience"
          description="Please add all relevant work experience. This information will build your Paro profile and help determine if your expertise is a good fit for the Paro network. Be sure to include all relevant tags for industry, software, and skills. Tags are especially important to define your true expertise at the end of registration and for matching you to projects once fully onboarded to the platform!"
        />
      </Box>

      <WorkExperienceForm initialValues={initialValues} />
    </>
  )
}

export default WorkExperience
